// Plausible Analytics integration using bundled npm package
//
// Reads configuration from meta tags injected by Rails helpers.
// Uses the @plausible-analytics/tracker npm package which bundles
// with the app's JavaScript (no external script loading needed).
//
// Manual pageview tracking on turbo:load for reliable Turbo Drive support.
//
// Privacy: Uses server-provided route pattern for authenticated pages
// to anonymize customer-specific data (org IDs, app IDs, tokens).

import { init, track } from '@plausible-analytics/tracker'

// Check if Plausible is enabled via meta tag (contains domain from AppConfig.host)
const domainMeta = document.querySelector('meta[name="plausible-domain"]')
if (domainMeta) {
  init({
    domain: domainMeta.content,
    endpoint: '/api/event', // First-party proxy
    autoCapturePageviews: false // We handle this manually for Turbo
  })

  // Track pageviews on Turbo navigation
  // turbo:load fires on initial page load AND on every Turbo navigation
  document.addEventListener('turbo:load', () => {
    // Use server-provided route pattern for privacy, fall back to actual path
    const pathMeta = document.querySelector('meta[name="plausible-path"]')
    const trackingPath = pathMeta?.content || window.location.pathname

    track('pageview', { u: window.location.origin + trackingPath })
  })
}
